import { defaultVariable, keyCloakConfig, urlReplace } from "common";
import { ApiEndPoint, getMethod, postMethod } from "services";

const getUserRole = (access: any) => {
    if (access) {
        const ret = defaultVariable?.allowedAccessRoles.filter((value: any) => access?.roles?.includes(value))?.toString();
        return ret;
    }
};

const getUsersOrganisations = async (userInfo: any) => {
    const allHosts: any = [];
    await getMethod(ApiEndPoint.usersHosts, '', false)
    .then((res) => {
        res.data?.hostId && allHosts.push(userInfo?.hostId);
        res.data?.associatedHosts?.forEach((host: any) => allHosts.push(host?.id));
    })
    .catch((err) => {
        console.error("Error", err);
        allHosts.push(userInfo?.hostId);
    });
    return allHosts
}

const getHostReportAccess = async (userInfo: any) => {
    const url = urlReplace(ApiEndPoint.reportCategoryAccess, "{HOST-ID}", userInfo?.sub);
    return await getMethod(url, '')
        .then((res) => {
            return res?.data ? res.data : [];
        })
        .catch((err) => {
            console.error("Error", err);
            return [];
        });
}

const getStationsListOfLocations = async (locationsIds: string[]) => {
    const data = {
        'locationIds': locationsIds
    }
    let stationList: string[] = []
    await postMethod(ApiEndPoint.stationsUnderLocations, '', data)
        .then((res) => {
            stationList = res?.data;
        })
        .catch((err) => {
            console.error("Error", err);
        })
    return stationList;
}

const bulkFetchData = async  (subUrls: string[]) => {
    //
    let responses = [];
    try {
        const apiPromises = subUrls.map(async url => {
            const response = await getMethod(url, '')
            return response?.data;
        });

        responses = await Promise.all(apiPromises);
   }
    catch(err) {
        console.error("Error", err);
    }
    finally {
        return responses
    }
}

export const getAccessPermissions = async () => {
    const userInfo = keyCloakConfig?.tokenParsed;
    const userRole = await getUserRole(userInfo?.realm_access);
    const reportsAccess = userRole ? await getHostReportAccess(userInfo) : [];
    console.log(`[If Host] Own Org's Report Permissions: `, reportsAccess);
    const organisations = await getUsersOrganisations(userInfo);
    console.log(`Organisations Linked: `, organisations);
    const zoneUrls: string[] = [];
    const locationsOfLocationPermission: string[] = [];
    const stationIds: string[] = [];
    let params = `?page=${0}&size=${1000}`
    let claims = new Set([]);
    const locationsKey = defaultVariable.powerBiCommonFiltersMap.locationId;
    const organisationsKey = defaultVariable.powerBiCommonFiltersMap.hostId;
    const stationsKey = defaultVariable.powerBiCommonFiltersMap.stationId;
    const defaultRetObj = {
        claims: new Set([]),
        filterValues: {},
        received: true
    }
    return await getMethod(ApiEndPoint.locationsV2, params, false)
        .then(async (res) => {
            if (res?.data?.locationsInfo) {
                let newFilterValues: any = {};
                let reportOptions: any = Array.from(claims);
                res?.data?.locationsInfo.forEach((loc: any) => {
                    //For Delegate/Host Users with Invited Zone Level Permissions, Individual Stations Fetched Later In Code
                    if (loc?.locationLevelReportPermissions === null && loc?.isZoneLevelPermissionApplied) {
                        zoneUrls.push(urlReplace(ApiEndPoint.locationZones, "{LOCATION-ID}", loc.locationId))
                    }
                    else if (loc?.locationLevelReportPermissions?.length) {
                        //For Delegate/Host Users with Invited Locations Level Permissions
                        locationsOfLocationPermission.push(loc.locationId);
                        console.log(`locationName: ${loc?.locationName} locationId: ${loc?.locationId} locationLevelReportPermissions: `, loc?.locationLevelReportPermissions)
                        loc?.locationLevelReportPermissions?.forEach((reportName: string) => {
                            let prevReportLocations = newFilterValues?.[reportName]?.[locationsKey] || [] //DOUBT !?? here it should be locationId, before it was locations
                            newFilterValues = {
                                ...newFilterValues,
                                [reportName]: {
                                    [organisationsKey]: organisations,
                                    [locationsKey]: [...prevReportLocations, loc?.locationId],
                                    [stationsKey]: []
                                }
                            }
                            reportOptions.push(defaultVariable.powerBiReportKeywordMap[reportName]);
                        })
                         //Adding for fetching their stations
                    }
                    else {
                        //For Host of same organisation
                        locationsOfLocationPermission.push(loc.locationId);
                        console.log(`locationName: ${loc?.locationName} locationId: ${loc?.locationId} locationLevelReportPermissions: `, loc?.locationLevelReportPermissions)
                        Array.from(reportsAccess)?.forEach((reportName: any) => {
                            let prevReportLocations = newFilterValues?.[reportName]?.[locationsKey] || [] //DOUBT !??
                            newFilterValues = {
                                ...newFilterValues,
                                [reportName]: {
                                    [organisationsKey]: organisations,
                                    [locationsKey]: !prevReportLocations.includes(loc?.locationId) ? [...prevReportLocations, loc?.locationId] : prevReportLocations,
                                    [stationsKey]: []
                                }
                            }
                            reportOptions.push(defaultVariable.powerBiReportKeywordMap[reportName]);
                        });
                    }
                })

                if (locationsOfLocationPermission.length) {
                    const stationsIdsOfLocationPermissions = await getStationsListOfLocations(locationsOfLocationPermission);
                    stationIds.push(...stationsIdsOfLocationPermissions);
                }

                reportOptions.forEach((tabName: string) => {
                    const reportName = defaultVariable.powerBiReportKeywordRevMap[tabName]
                    newFilterValues = {
                        ...newFilterValues,
                        [reportName]: {
                            ...newFilterValues[reportName],
                            [stationsKey]: stationIds
                        }
                    }
                })

                const zoneLocationIds: string[] = [];
                if (zoneUrls.length) {
                    const zonesData = await bulkFetchData(zoneUrls);
                    zonesData.forEach((res: any) => {
                        zoneLocationIds.push(res.locationId);
                        res.zones.forEach((zone: any) => {
                            zone?.reportPermissions?.forEach((permision: string) => {
                                reportOptions.push(defaultVariable.powerBiReportKeywordMap[permision])
                                newFilterValues = {
                                    ...newFilterValues,
                                    [permision]: {
                                        ...newFilterValues[permision],
                                        [organisationsKey]: organisations,
                                        [locationsKey]: locationsOfLocationPermission.concat([res.locationId]),
                                        [stationsKey]: stationIds.concat(zone.stations.map((s:any) => s.id))
                                    }
                                }
                            })
                            console.log(`zone: ${zone.name} stationIds: `, stationIds.concat(zone.stations.map((s:any) => s.id)), ` zoneReportPermissions: ${zone?.reportPermissions}`);
                        })
                    })
                }
                
                const retObj = {
                    claims: new Set(reportOptions),
                    filterValues: newFilterValues,
                    received: true
                }
                return retObj;
            }
            else {
                return defaultRetObj
            }
        })
        .catch((err) => {
            console.error("Error", err);
            return defaultRetObj;
        });
};